import { MatSnackBar } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';
import { CustomSnackbarComponent } from './snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  private openSnackBar(status: 'success' | 'error' | 'info', text: string) {

    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: { text },
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: [`${status}-snackbar`],
      duration: 10000
    });
  }

  showSuccess(content: string) {
    this.openSnackBar('success', content);
  }

  showError(content: string) {
    this.openSnackBar('error', content);
  }

  showInfo(content: string) {
    this.openSnackBar('info', content);
  }
}
